import React from 'react';
import { Consumer } from 'contexts/Currency/CurrencyContext';

export default ConnectedComponent => props => (
    <Consumer>
        {({ state }) => <ConnectedComponent {...props} {...state} />}
    </Consumer>
);
